import { DtDropSelect } from '@ow/ditto-core'

const { validation, transformer, filterSpec } = DtDropSelect

export { default as Render } from './render'
export { default as Filter } from './filter'
export { default as Statistics } from './statistics'
// export { filterSpec, config } from './config'
// export { default as transformer } from './transformer'
// export { default as validation } from './validation'
export { validation, transformer, filterSpec }
